import tw from "twin.macro"

import React from "react"
import { createRoot } from "react-dom/client"
import InlineSVG from "react-inlinesvg"
import styled from "styled-components/macro"

// @ts-ignore

import { Provider, createClient } from "urql"

import { GradientDiv } from "components/GradientButton"
import {
  Wishlists_ProductsQuery,
  useWishlists_ProductsQuery,
} from "components/graphql"
import { formatPrice } from "components/utils"

import GoodyLogoGradient from "../assets/goody-logo-gradient.svg"

const graphqlUrl = "/graphql"
const client = createClient({
  url: graphqlUrl,
})

const WishlistApp: React.FC = () => {
  return (
    <Provider value={client}>
      <Wishlist />
    </Provider>
  )
}

const Wishlist: React.FC = () => {
  const [{ data }] = useWishlists_ProductsQuery({
    variables: {
      // @ts-ignore
      products: window.wishlistItems.split(","),
    },
  })

  return (
    <div>
      <div tw="bg-primary-100">
        <div tw="container mx-auto text-center py-9 pb-24">
          <InlineSVG src={GoodyLogoGradient} />
          <h1 tw="mt-0 pt-4 text-2xl text-primary-500 font-normal">
            {window.wishlistFullName}&rsquo;s Wishlist
          </h1>
        </div>
      </div>
      <div tw="bg-white p-6 rounded-xl -mt-20 shadow-lg max-w-lg mx-auto text-center">
        <div tw="uppercase text-sm font-medium text-gray-400">
          {window.wishlistFirstName}&rsquo;s favorite things on Goody
        </div>
        <div tw="pt-2 leading-snug pb-6">
          Tap any gift to open the Goody app and send the gift to{" "}
          {window.wishlistFirstName}.{" "}
          <span tw="font-medium">No address needed</span>.
        </div>
        <a
          href="https://get.ongoody.com/"
          tw="uppercase text-sm font-medium text-primary-500 hover:text-primary-700 transition-colors"
        >
          Create your own wishlist
        </a>
      </div>
      <div tw="px-8 pt-12">
        <div tw="w-full max-w-5xl mx-auto">
          <div tw="grid md:grid-cols-2 gap-12">
            {data?.products?.map((product) => (
              <ListItem product={product} />
            ))}
          </div>
        </div>
      </div>
      <div tw="pt-48 pb-24 text-sm text-gray-400 text-center">
        &copy;2021 Goody Technologies, Inc. -{" "}
        <a tw="text-gray-400" href="https://ongoody.com/terms">
          Terms of Use
        </a>{" "}
        -{" "}
        <a tw="text-gray-400" href="https://ongoody.com/privacy">
          Privacy Policy
        </a>
      </div>
    </div>
  )
}

const ListItem: React.FC<{ product: Wishlists_ProductsQuery["products"] }> = ({
  product,
}) => {
  if (!product) {
    return null
  }

  return (
    <a
      tw="shadow-lg rounded-xl border border-gray-100 flex flex-col no-underline hover:shadow-2xl transition-all text-black"
      href={`https://get.ongoody.com/cross-link?gift_option=${product.associatedGiftOptionId}&username=${window.wishlistUsername}`}
      target="_blank"
      rel="noreferrer noopener"
    >
      {product.primaryImage?.imageLarge && (
        <div tw="w-full">
          <img
            tw="w-full rounded-t-xl block"
            src={product.primaryImage.imageLarge.url}
          />
        </div>
      )}
      <div tw="p-4 px-6 w-full">
        <div tw="flex flex-row items-start justify-between">
          <div>
            <div tw="text-xl">{product.name}</div>
            <div tw="text-sm pt-1 text-gray-500">{product.brandName}</div>
          </div>
          <div>
            <div tw="text-right">{formatPrice(product.price)}</div>
            <div tw="text-right text-sm pt-1 text-gray-500">
              {formatPrice(product.shippingPrice)} shipping
            </div>
          </div>
        </div>
        <div tw="pt-4 text-sm text-gray-500">{product.subtitle}</div>
      </div>
      <div tw="p-2 mt-auto w-full">
        <GradientDiv>Gift to {window.wishlistFirstName}</GradientDiv>
      </div>
    </a>
  )
}

export function renderWishlist() {
  createRoot(document.querySelector("#wishlist-root")).render(<WishlistApp />)
}
